import Vue from 'vue'
import { required, email, max, min, min_value, max_value, confirmed, regex } from 'vee-validate/dist/rules'
import { extend, ValidationObserver, ValidationProvider } from 'vee-validate'

extend('required', {
  ...required,
  message: '{_field_} cannot be empty'
})

extend('max', {
  ...max,
  message: '{_field_} max {length} character'
})

extend('min', {
  ...min,
  message: '{_field_} min {length} character'
})

extend('min_0', {
  ...min_value,
  message: '{_field_} min 0'
})

extend('max_100', {
  ...max_value,
  message: '{_field_} max 100'
})

extend('min_price', {
  ...min_value,
  message: '{_field_} min Rp 10.000'
})

extend('max_price', {
  ...max_value,
  message: '{_field_} max Rp 1.000.000'
})

extend('email', {
  ...email,
  message: '{_field_} email is not correct'
})

extend('confirmed', {
  ...confirmed,
  message: '{_field_} password confirmation is incorrect'
})

extend('regex', {
  ...regex,
  message: '{_field_} must contain 1 lowercase letter, 1 uppercase letter & 1 character'
})

Vue.component('ValidationObserver', ValidationObserver)
Vue.component('ValidationProvider', ValidationProvider)

export default {
  components: {
    ValidationObserver,
    ValidationProvider
  }
}